'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ID_MENU } from '@/ui/segments/landing/constants';
import { classNames } from '@/util/utils';
import styles from './next-panel.module.css';
interface NextPanelProps {
  className?: string;
  testId?: string;
  children: string | null;
}
export default function NextPanel(t0) {
  const $ = _c(10);
  const {
    className,
    testId,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(className, styles.nextPanel);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = children ?? "Button";
  let t3;
  if ($[2] !== children) {
    t3 = <div>{children}</div>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={styles.ruler} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== testId) {
    t5 = <button className={t1} type="button" aria-label={t2} data-testid={testId} onClick={handleNextPage}>{t3}{t4}</button>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = testId;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}

/**
 * Scroll down of a whole page height.
 */
function handleNextPage() {
  const menu = document.getElementById(ID_MENU);
  const height = menu?.clientHeight ?? 0;
  window.scrollTo({
    top: window.innerHeight - height,
    behavior: 'smooth'
  });
}